import { FunctionComponent } from "react";

import "./index.scss";

export const Logo: FunctionComponent = () => {
  return <div id="logo">Logo</div>;
};
